import { useEffect, useState } from 'react';
import { notifySentry } from 'utils/error/notifySentry';
import { apiInstance } from './api';

export type PVCalcProps = {
  lng: number;
  lat: number;
  peakPower: number; // KWc = numPanels * panel power
  roofAngle: number; // = roof angle
  orientation: number; // = orientation (south = 0, north = 180)
  loss?: number;
};

const useGetPVCalc = ({
  lng,
  lat,
  peakPower,
  roofAngle,
  orientation,
  loss = 10, // TODO: check if this is still ok
}: PVCalcProps) => {
  const pvUrl = `/getPVCalc?lat=${lat}&lon=${lng}&peakpower=${peakPower}&loss=${loss}&angle=${roofAngle}&aspect=${orientation}&usehorizon=1&pvcalculation=1&outputformat=json`;
  const [yearlyProduction, setYearlyProduction] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    if (!pvUrl || (lat === -1 && lng === -1)) return;
    apiInstance
      .get(pvUrl)
      .then((response) => {
        if (response.data.outputs.totals) {
          setYearlyProduction(response.data.outputs.totals.fixed.E_y);
        } else
          console.warn(`No totals for response: ${JSON.stringify(response)}`);
      })
      .catch((error) => {
        notifySentry(`error with PVCalc:`, error);
      });
  }, [pvUrl, lat, lng]);
  return { yearlyProduction };
};

export default useGetPVCalc;
